import { render } from "./ProductOperation.vue?vue&type=template&id=1016c0d3&scoped=true"
import script from "./ProductOperation.vue?vue&type=script&lang=js"
export * from "./ProductOperation.vue?vue&type=script&lang=js"

import "./ProductOperation.vue?vue&type=style&index=0&id=1016c0d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1016c0d3"]])

export default __exports__